import { IEditTeaserState } from './editTeaserContext';
import { EditTeaserActionTypes, TEditTeaserAction } from './editTeaserActions';

export const editTeaserReducer = (state: IEditTeaserState, action: TEditTeaserAction): IEditTeaserState => {
	switch (action.type) {
		case EditTeaserActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetch,
				fileId: null,
			};
		case EditTeaserActionTypes.SET_INITIAL_FORM_DATA:
			return {
				...state,
				initialFormData: action.payload.initialFormData,
			};
		case EditTeaserActionTypes.SET_ALL_DATA:
			return {
				...state,
				teaserID: action.payload.teaserID,
				filePath: action.payload.filePath,
				selectedCustomer: action.payload.selectedCustomer,
				selectedRestaurants: action.payload.selectedRestaurants,
				selectedContentType: action.payload.selectedContentType,
				description: action.payload.description,
				schedule: action.payload.schedule,
				totalSchedules: action.payload.totalSchedules,
				selectedTransitionType: action.payload.selectedTransitionType,
				dishTransition: action.payload.dishTransition,
				selectedTransitionDishCategory: action.payload.selectedTransitionDishCategory,
				selectedTransitionDishSubCategory: action.payload.selectedTransitionDishSubCategory,
				selectedTransitionDishName: action.payload.selectedTransitionDishName,
				selectedTransitionGameCategory: action.payload.selectedTransitionGameCategory,
				selectedTransitionGameName: action.payload.selectedTransitionGameName,
				selectedControlPoint: action.payload.selectedControlPoint,
				delayTime: action.payload.delayTime,
				launchCount: action.payload.launchCount,
				countDown: action.payload.countDown,
			};
		case EditTeaserActionTypes.CHANGE_VISIBLE_FORM:
			return {
				...state,
				visibleForm: action.payload.visibleForm,
			};
		case EditTeaserActionTypes.SET_FILE:
			return {
				...state,
				fileId: action.payload.fileId,
				sourceUrlLocally: action.payload.sourceUrlLocally,
			};
		case EditTeaserActionTypes.DELETE_VIDEO:
			return {
				...state,
				filePath: null,
				fileId: null,
				sourceUrlLocally: null,
			};
		case EditTeaserActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.customers,
			};
		case EditTeaserActionTypes.SET_CUSTOMER:
			return {
				...state,
				selectedCustomer: action.payload.customer,
				selectedRestaurants: [],
				fetchedRestaurants: [],
				fetchedDishCategories: [],
				selectedTransitionDishCategory: null,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
				fetchedGameCategories: [],
				selectedTransitionGameCategory: null,
				fetchedGames: [],
				selectedTransitionGameName: null,
			};
		case EditTeaserActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case EditTeaserActionTypes.SET_RESTAURANTS:
			return {
				...state,
				selectedRestaurants: action.payload.restaurants,
				fetchedDishCategories: [],
				selectedTransitionDishCategory: null,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
				fetchedGameCategories: [],
				selectedTransitionGameCategory: null,
				fetchedGames: [],
				selectedTransitionGameName: null,
			};
		case EditTeaserActionTypes.SET_CONTENT_TYPE:
			return {
				...state,
				selectedContentType: action.payload.contentType,
				sourceUrlLocally: null,
				fileId: null,
				filePath: null,
				schedule: '',
				totalSchedules: [],
				selectedTransitionType: null,
				selectedTransitionDishCategory: null,
				selectedTransitionDishSubCategory: null,
				selectedTransitionDishName: null,
				selectedTransitionGameCategory: null,
				selectedTransitionGameName: null,
				selectedControlPoint: null,
				delayTime: '',
				launchCount: '',
				countDown: '',
			};
		case EditTeaserActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case EditTeaserActionTypes.CHANGE_SCHEDULE:
			return {
				...state,
				schedule: action.payload.schedule,
			};
		case EditTeaserActionTypes.CHANGE_ADDITIONAL_SCHEDULE:
			return {
				...state,
				totalSchedules: action.payload.updatedSchedules,
			};
		case EditTeaserActionTypes.SET_SCHEDULES:
			return {
				...state,
				totalSchedules: action.payload.updatedSchedules,
			};
		case EditTeaserActionTypes.SET_TRANSITION_TYPE:
			return {
				...state,
				selectedTransitionType: action.payload.transitionType,
				selectedTransitionDishCategory: null,
				selectedTransitionDishSubCategory: null,
				selectedTransitionGameName: null,
				selectedTransitionGameCategory: null,
				selectedTransitionDishName: null,
			};
		case EditTeaserActionTypes.SET_FETCHED_DISH_CATEGORIES:
			return {
				...state,
				fetchedDishCategories: action.payload.dishCategories,
			};
		case EditTeaserActionTypes.SET_TRANSITION_DISH_CATEGORY:
			return {
				...state,
				selectedTransitionDishCategory: action.payload.transitionDishCategory,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
			};
		case EditTeaserActionTypes.SET_FETCHED_DISH_SUB_CATEGORIES:
			return {
				...state,
				fetchedDishSubCategories: action.payload.dishSubCategories,
			};
		case EditTeaserActionTypes.SET_TRANSITION_DISH_SUB_CATEGORY:
			return {
				...state,
				selectedTransitionDishSubCategory: action.payload.transitionDishSubCategory,
				fetchedDishes: [],
				selectedTransitionDishName: null,
			};
		case EditTeaserActionTypes.SET_FETCHED_DISHES:
			return {
				...state,
				fetchedDishes: action.payload.dishes,
			};
		case EditTeaserActionTypes.SET_TRANSITION_DISH_NAME:
			return {
				...state,
				selectedTransitionDishName: action.payload.transitionDishName,
			};
		case EditTeaserActionTypes.SET_FETCHED_GAME_CATEGORIES:
			return {
				...state,
				fetchedGameCategories: action.payload.gameCategories,
			};
		case EditTeaserActionTypes.SET_TRANSITION_GAME_CATEGORY:
			return {
				...state,
				selectedTransitionGameCategory: action.payload.transitionGameCategory,
				fetchedGames: [],
				selectedTransitionGameName: null,
			};
		case EditTeaserActionTypes.SET_FETCHED_GAMES:
			return {
				...state,
				fetchedGames: action.payload.games,
			};
		case EditTeaserActionTypes.SET_TRANSITION_GAME_NAME:
			return {
				...state,
				selectedTransitionGameName: action.payload.transitionGameName,
			};
		case EditTeaserActionTypes.SET_CONTROL_POINT:
			return {
				...state,
				selectedControlPoint: action.payload.controlPoint,
			};
		case EditTeaserActionTypes.CHANGE_DELAY_TIME:
			return {
				...state,
				delayTime: action.payload.delayTime,
			};
		case EditTeaserActionTypes.CHANGE_LAUNCH_COUNT:
			return {
				...state,
				launchCount: action.payload.launchCount,
			};
		case EditTeaserActionTypes.CHANGE_COUNTDOWN:
			return {
				...state,
				countDown: action.payload.countDown,
			};
		case EditTeaserActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case EditTeaserActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case EditTeaserActionTypes.RESET_FIELDS:
			return {
				...state,
				fileId: null,
				sourceUrlLocally: null,
				fetchedCustomers: [],
				selectedCustomer: null,
				fetchedRestaurants: [],
				selectedRestaurants: [],
				selectedContentType: null,
				description: '',
				schedule: '',
				totalSchedules: [],
				selectedTransitionType: null,
				fetchedDishCategories: [],
				selectedTransitionDishCategory: null,
				fetchedDishSubCategories: [],
				selectedTransitionDishSubCategory: null,
				fetchedDishes: [],
				selectedTransitionDishName: null,
				fetchedGameCategories: [],
				selectedTransitionGameCategory: null,
				fetchedGames: [],
				selectedTransitionGameName: null,
				selectedControlPoint: null,
				delayTime: '',
				launchCount: '',
				countDown: '',
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
